import { Question } from "../../../API";
import * as xlsx from "xlsx";
import { AssignmentResult, Student } from "../types";

type TableRow = {
  nickname: string;
  attemptNo: number;
  score: string;
  answerMarks: boolean[];
};

export function exportResultsTable(
  assignmentResults: AssignmentResult[],
  students: Student[],
  questions: (Question | null | undefined)[]
) {
  const rows: TableRow[] = assignmentResults.map((result) => {
    const student = students.find(
      (student) => student.studentId === result.studentId
    );
    const nickname = student?.nickname ?? "-";
    const attemptNo = result.attempt;
    const numCorrect = result.answerResults.filter((r) => r.isCorrect).length;
    const totalQuestions = questions.length;

    const score = `${(numCorrect / totalQuestions) * 100}%`;

    const answerMarks = questions.map((_, i) => {
      const answerResult = result.answerResults.find(
        (r) => r.questionIndex === i
      );
      return answerResult?.isCorrect ?? false;
    });

    return { nickname, attemptNo, score, answerMarks };
  });

  const headers = [
    "Nickname",
    "Attempt",
    "Score",
    ...questions.map((q, i) => `Q${i + 1}: ${q?.text ?? ""}`),
  ];
  const data = [
    headers,
    ...rows.map((row) => [
      row.nickname,
      row.attemptNo,
      row.score,
      ...row.answerMarks.map((mark) => (mark ? 1 : 0)),
    ]),
  ];

  const worksheet = xlsx.utils.aoa_to_sheet(data);
  const workbook = xlsx.utils.book_new();
  xlsx.utils.book_append_sheet(workbook, worksheet, "Results");

  const date = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  xlsx.writeFile(workbook, `Gibbly_Assignment_Results_${date}.csv`);
}
